export const PillButtonType = {
    PRIMARY: "PRIMARY",
    SECONDARY: "SECONDARY"
}